import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BuildCache = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M3.55996 3.17648C6.25339 2.9607 9.74663 2.9607 12.4401 3.17648C13.4423 3.25677 14.2365 4.00833 14.4176 4.97172C14.8663 7.35881 15.138 9.14271 15.2219 11.1306C15.2713 12.2999 14.3836 13.2865 13.2182 13.3651C10.2628 13.5645 5.73716 13.5645 2.78184 13.3651C1.61643 13.2865 0.728732 12.2999 0.778101 11.1306C0.862034 9.14271 1.13377 7.35881 1.58243 4.97172C1.76351 4.00833 2.55775 3.25677 3.55996 3.17648ZM7.5 6V11H6V6H7.5ZM5 7V11H3.5V7H5ZM11 7H12.5V11H11V7ZM10 11V9H8.5V11H10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default BuildCache;
